module.exports = __webpack_public_path__ + "static/arvind_ananthanarayanan-5bf0c014565c7db1f2a92fc7a54ba01c.png";